// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"b448890b","160":"4a0310bb","309":"7ccbe422","784":"346c00ab","812":"0231899d"}[chunkId] + ".chunk.css";
};